"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuItemShape = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _map = _interopRequireDefault(require("lodash/map"));
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
var _MenuItemWithSubmenu = _interopRequireDefault(require("./MenuItemWithSubmenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var menuItemShape = {
  /** Name of the Icon; should exist in Icons */
  icon: _propTypes["default"].string.isRequired,
  /** Text Displayed next to the icon */
  text: _propTypes["default"].string,
  /** State for the menu item */
  isActive: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  /** Menu item has been found by Search field */
  isHighlighted: _propTypes["default"].bool,
  /** An array of submenu items; Each submenu item should have props for text, isActive and other link related props that will get spread on the item */
  submenuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string,
    isActive: _propTypes["default"].bool,
    isHighlighted: _propTypes["default"].bool
  }))
};
exports.menuItemShape = menuItemShape;
var propTypes = {
  /** An array of menu items */
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(menuItemShape)),
  /** Wether the menu is open or closed */
  isMenuOpen: _propTypes["default"].bool,
  /** Function to open the menu */
  openMenu: _propTypes["default"].func,
  /** Search input value */
  searchValue: _propTypes["default"].string
};
var MenuItemsList = function MenuItemsList(_ref) {
  var menuItems = _ref.menuItems,
    isMenuOpen = _ref.isMenuOpen,
    openMenu = _ref.openMenu,
    searchValue = _ref.searchValue;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _map["default"])(menuItems, function (item, index) {
    var Component = item.submenuItems ? _MenuItemWithSubmenu["default"] : _MenuItem["default"];
    var props = item.submenuItems ? {
      isMenuOpen: isMenuOpen,
      openMenu: openMenu
    } : {};
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      key: index,
      searchValue: searchValue
    }, props, item));
  }));
};
MenuItemsList.propTypes = propTypes;
var _default = MenuItemsList;
exports["default"] = _default;